import { render, staticRenderFns } from "./Fba.vue?vue&type=template&id=6e9b29d4&scoped=true&"
import script from "./Fba.vue?vue&type=script&lang=js&"
export * from "./Fba.vue?vue&type=script&lang=js&"
import style0 from "./Fba.vue?vue&type=style&index=0&id=6e9b29d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9b29d4",
  null
  
)

export default component.exports